import styled from "styled-components";
import { TColor } from "../../types";
import { colorMixin, typographyMixin, getShadow, IPaddingStyleProps, paddingMixin } from "../../helpers";

export const Banner = styled.div<
    {
        $textColor: TColor;
        $backgroundColor: TColor;
        $borderColor: TColor;
        $noShadow: boolean;
    } & IPaddingStyleProps
>`
    ${typographyMixin("label-small-regular")};
    color: ${({ $textColor }) => colorMixin($textColor)};
    background: ${({ $backgroundColor }) => colorMixin($backgroundColor)};
    border: 1px solid ${({ $borderColor }) => colorMixin($borderColor)};
    box-shadow: ${({ $noShadow = false, theme }) => ($noShadow ? "none" : getShadow(theme, "shadow-small-default"))};
    padding: 12px 10px;
    border-radius: 4px;

    ${paddingMixin()};

    ul {
        margin: 0;
        padding: 0 0 0 14px;
    }
`;
